<template>
    <div class="sidebar__section sidebar__section--border-bottom">
        <div class="route-summary">
            <div class="route-summary__top" :class="{'route-summary__top--margin': !route.departureArrival}">
                <div class="route-summary__infos h3  ui-center-vertically">
                    <span class="dot-divider dot-divider--info ui-center-vertically" :class="route.durationColor">
                        <span class="ui-nowrap" :class="{'cancelled' : route.hasCancellation}">{{ route.duration }}</span>
                        <span class="tag tag--medium tag--orange ui-nowrap" v-if="route.delays && route.delays.arrival">+ {{ route.delays.arrival }}</span>
                    </span>
                    <span class="ui-nowrap dot-divider dot-divider--multiline dot-divider--wide dot-divider--big" v-if="route.distance">{{ route.distance }}</span>
                    <span class="ui-nowrap dot-divider dot-divider--multiline dot-divider--wide dot-divider--big" v-if="route.departureArrival">
                        <span class="h2">{{ route.departure }}</span>
                        <span v-if="route.departure" class="h2" :class="route.delayDeparture !== 0  ? 'delay' : 'early'"> {{ route.delayDeparture >= 0 ? '+' : '' }}{{ route.delayDeparture }}</span>
                        <span> - </span>
                        <span class="h2">{{ route.arrival }}</span>
                        <span v-if="route.arrival" class="h2" :class="route.delayArrival !== 0  ? 'delay' : 'early'"> {{ route.delayArrival >= 0 ? '+' : '' }}{{ route.delayArrival }}</span>
                    </span>
                </div>
                <MoreActions 
                    :favourite-object="favouriteObject" 
                    :actions="actions"
                    :tooltips="tooltipsContent"
                    :showSharingActions="showSharingActions"
                    :title="showSharingActions ? 'Route teilen' : undefined"
                    @pdf="pdfHandler"
                    @share="shareHandler"
                    @export="exportHandler"
                    @traffic-alert="trafficAlertHandler"
                    @moreActionsPopperClosed="moreActionsPopperClosedHandler"
                />
            </div>
            <WaypointSummary :waypoints="routeWaypoints" :compactToggleable="waypointSummaryToggleable" :showInterimAsNumbers="true" :distancesBetweenWaypoints="route.interimDistances" />
            <div class="route-summary__cancelled copy-light red" v-if="route.hasCancellation">
                Verbindung entfällt
            </div>
            <div class="route-summary__cancelled copy-ligh red" v-else-if="route.hasUnreachableConnection">
                Anschluss kann voraussichtlich nicht erreicht werden
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { TRAFFIC_ALERT_TRANSPORT_MODES, NO_INTERMEDIATE_STOP_TRANSPORT_MODES } from '@/data/transportModesTypes'
import eventBus from '@/utils/event-bus';
import MoreActions from '@/components/MoreActions.vue'
import WaypointSummary from '@/components/WaypointSummary.vue'
import { shareLink } from '@/utils/sharing'

export default {
    components: {
        MoreActions,
        WaypointSummary,
    },
    props: {
        route: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            showSharingActions: false,
            tooltipsContent: {
                moreActions: {
                    content: 'Weitere Optionen anzeigen',
                    position: 'bottom-end'
                },
                favourites: {
                    full: {
                        content: 'Route löschen',
                        position: 'right'
                    },
                    empty: {
                        content: 'Route speichern',
                        position: 'right',
                    }
                } 
            }
        }
    },
    computed: {
        ...mapGetters(['routeWaypoints', 'mobile']),
        favouriteObject() {
            return {
                type: 'route',
                mode: this.route.mode,
                polylines: this.route.polylines,
                duration: this.route.durationUnformatted,
                distance: this.route.distanceUnformatted
            }
        },

       actions() {
           let actions = [
                {
                    'icon': 'IconBell',
                    'label': 'Traffic Alert einrichten',
                    'event': 'traffic-alert'
                },
                {
                    'icon': 'IconPdf',
                    'label': 'Route als PDF speichern / drucken',
                    'event': 'pdf'
                },
                {
                    'icon': 'IconShare',
                    'label': 'Route teilen',
                    'event': 'share',
                    'keepPopperOpen': true,
                },
                // {
                //     'icon': 'IconExport',
                //     'label': 'Route exportieren',
                //     'event': 'export'
                // },
            ];

            if (!TRAFFIC_ALERT_TRANSPORT_MODES.includes(this.route.mode)) {
                actions = actions.slice(1);
            }

            return actions;
       },
       waypointSummaryToggleable() {
            return !NO_INTERMEDIATE_STOP_TRANSPORT_MODES.includes(this.route.mode)
       }
    },
    methods: {
        pdfHandler() {
            eventBus.$emit('showPrintPreview', this.route.id)
        },
        shareHandler() {
            if(navigator.share && this.mobile) {
                shareLink()
            } else {
                this.showSharingActions = true
            }
        },
        exportHandler() {
            console.log('handle export');
        },
        trafficAlertHandler() {
            eventBus.$emit('showFavouritesPanel', {
                type: 'route',
                mode: this.route.mode,
                polylines: this.route.polylines,
                trafficAlert: true,
                duration: this.route.durationUnformatted,
                distance: this.route.distanceUnformatted
            });
        },
        moreActionsPopperClosedHandler() {
            setTimeout(() => {
                this.showSharingActions = false
            }, 300);
        }
    }
}
</script>

<style lang="scss">
.route-summary {
    padding: 23px 0;

    &__top {
        display: flex;
        justify-content: space-between;
        &:not(:last-child){
            margin-bottom: 8px;
        }
        
        &--margin {
            &:not(:last-child){
                margin-bottom: 10px;
            }
        }

        .delay {
            color: $color-red;
        }

        .early {
            color: $color-green;
        }
    }

    &__infos {
        overflow: hidden;
        flex-wrap: wrap;

        .tag {
            margin-left: 6px;
        }
    }

    &__actions {
        display: flex;
        align-items: center;
        color: $color-grey-dark;
        flex-shrink: 0;

        &__item {
            margin: 0 6px;
            cursor: pointer;
            svg {
                display: block;
            }
            &:first-child {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    &__cancelled {
        margin-top: 12px;
        padding-left: 24px;
    }
}
</style>